import { h } from 'preact';
import { CheckboxEntry } from '@epx/flow';

const TASK_TYPES = ['epx:UserTask', 'epx:ManualTask'];

export class SfdAdminProcessPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return TASK_TYPES.includes(elementType);
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    const boolField = (propKey, label) => ({
      id: propKey,
      component: () => (
        <CheckboxEntry
          id={`sfd-${propKey}`}
          label={label}
          checked={props[propKey] === true || props[propKey] === 'true'}
          onChange={(val) => update(propKey, val)}
        />
      ),
    });

    const ADMIN_KEYS = ['automaticAssignment', 'approvalRequired', 'sendBackActivity',
      'electDocRequired', 'publishDocument', 'publishAttachments', 'publishRelatedDocument'];

    return [
      {
        id: 'adminProcess',
        label: i18n.adminProcess || 'Admin Process',
        isEdited: () => ADMIN_KEYS.some(k => props[k] === true || props[k] === 'true'),
        entries: [
          boolField('automaticAssignment', i18n.automaticAssignment || 'Automatic Assignment'),
          boolField('approvalRequired', i18n.approvalRequired || 'Approval Required'),
          boolField('sendBackActivity', i18n.sendBackActivity || 'Allow Send Back'),
          boolField('electDocRequired', i18n.electDocRequired || 'Electronic Doc Required'),
          boolField('publishDocument', i18n.publishDocument || 'Publish Document'),
          boolField('publishAttachments', i18n.publishAttachments || 'Publish Attachments'),
          boolField('publishRelatedDocument', i18n.publishRelatedDocument || 'Publish Related Document'),
        ],
      },
    ];
  }
}
